import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router';
import Loading from "../../../../components/loading/loading";
import ListingService from "../../../../services/listing-service";
import TermSheetSecurities from "../../../issuer/listing/listing-details/components/term-sheet-securities/term-sheet-securities";
import TermSheetParticipants from "../../../issuer/listing/listing-details/components/term-sheet-participants/term-sheet-participants";
import AdminRequiredDocuments from "./components/admin-required-documents/admin-required-documents";
import AdminTermSheetDetails from "./components/admin-term-sheet-details/admin-term-sheet-details";
import {useHistory, useLocation} from "react-router-dom";

const AdminListingDetails = () => {
  //Retrieve security id from params
  const { applicationId }  = useParams();
  //Set spinner state
  const [loading, setLoading] = useState(true);
  const [termSheet, setTermSheet] = useState({})
  const [requiredDocuments, setRequiredDocuments] = useState([])
  const listingService = new ListingService();
  const history = useHistory();
  const query = new URLSearchParams(useLocation().search);
  const institutionCode = query.get('ic');

  useEffect(()=> {
    const retrieveTermSheetDetails = async () => {
      try {
        const result = await listingService.retrieveTermSheetDetails(institutionCode, applicationId);
        setTermSheet(result);
        console.log("TEERMSHEET DETAILS");
        console.log(result);
        const documentList = await listingService.retrieveRequiredDocuments(institutionCode, applicationId)
        setRequiredDocuments(documentList);
      } catch(error){
        if (error.response.status === 404){
          history.push(`/resource-not-found`);
        }else {
          history.push(`/internal-server-error`);
        }
      } finally {
        setLoading(false);
      }

    }
    retrieveTermSheetDetails();
    // eslint-disable-next-line
  }, []);

  const computePercentage = () => {
    const tabLength = 8;
    const tabSubmitted = termSheet.applicationStatus === '0' ? parseInt(termSheet.activeTabIndex) : 8;
    // const docLength = requiredDocuments.length;
    // const docSubmitted = requiredDocuments.filter(d => d.documentStatus === '1').length;
    //console.log(tabSubmitted);
    return Math.ceil(tabSubmitted/tabLength*100);
  }

  return loading ? <Loading /> : (
    <>
      <AdminTermSheetDetails context={{computePercentage, termSheet, setTermSheet}}/>
      <TermSheetSecurities context={{termSheet, setTermSheet}} admin={true} />
      <TermSheetParticipants context={{termSheet, setTermSheet}} admin={true} />
      <AdminRequiredDocuments context={{applicationId, requiredDocuments, setRequiredDocuments}}/>
    </>
  )
}

export default AdminListingDetails;
